export default __webpack_public_path__ + "static/media/vermapa.c211c12c.svg";